// extracted by mini-css-extract-plugin
module.exports = {"container":"Credits_container__1cd8J","title":"Credits_title__2O3xO"};